export default {"src":"/_next/static/media/crypto-street-logo.1e7097d8.svg","height":280,"width":1080,"blurWidth":0,"blurHeight":0};